<script setup lang="ts">
import { AuthLocalStorageKeys, TermsStatus } from '@store/auth/types';

const emit = defineEmits<{
    close: [];
}>();
const authStore = useAuthStore();
function acceptTerms() {
    emit('close');
    authStore.termsStatus = TermsStatus.Accepted;
    localStorage.setItem(
        AuthLocalStorageKeys.termsStatus,
        TermsStatus.Accepted
    );
}
</script>
<template>
    <mr-modal hide-header>
        <h1>شرایط استفاده از پنل سازمانی:</h1>
        <p>
            1- شرایط و مقررات خرید و استرداد، تابع شرایط و مقررات خدمات‌دهنده
            (شرکت‌های هواپیمایی و چارترکننده‌ها) است.
        </p>
        <p>
            2-: مِستربلیط موظف به ارائه پشتیبانی تلفنی 24 ساعته عمومی در ساعات
            غیراداری به طرف دوم است.
        </p>
        <p>
            3- براساس بخشنامه 200/24249/ص مورخ 28/12/98 سازمان امور مالیاتی کشور
            بلیط پرواز به منزله فاکتور تلقی می‌گردد، و نیز نظر به اینکه طبق
            مقررات بند 12 ماده 12 و حکم ماده 40 قانون مالیات بر ارزش افزوده،
            خدمات حمل و نقل عمومی مسافری درون و برون شهری، جاده‌ای، ریلی، هوایی
            و دریایی از پرداخت مالیات و عوارض معاف می‌باشند بلیط پرواز مشمول
            مالیات بر ارزش افزوده نیست.
        </p>
        <p>
            4- در صورت وجود مغایرت در صورتحساب، طرف دوم موظف است ظرف 3 روز نسبت
            به رفع مغایرت اقدام نماید.
        </p>
        <p>
            5- خریدار متعهد است بر عملکرد افراد و کارکنانی که به نمایندگی از
            ایشان مبادرت به خرید بلیط و هتل‌های موجود در سامانه شرکت می‌نمایند
            نظارت دقیق نماید همچنین خریدار متعهد است دسترسی افراد و کارکنانی که
            به هر علت در زمینه موضوع این قرارداد تخلف یا تقصیراتی را مرتکب
            می‌شوند در اسرع وقت قطع نماید. مسئولیت حفاظت از نام کاربری و رمز
            عبور به عهده خریدار بوده و مسئولیت هرگونه عملکرد در داخل پنل به عهده
            خریدار می‌باشد و موظف است در ثبت خرید و درخواست‌ها دقت لازم را مبذول
            نماید. در صورت بروز هرگونه اشتباه احتمالی، خسارات وارده متوجه
            مِستربلیط نخواهد بود.
        </p>
        <p>
            6- خریدار موظف است در مورد زمان و مکان حرکت به مسافران اطلاع‌رسانی
            لازم را انجام دهد و در صورت تأخیر و دیر رسیدن مسافر به وسیله سفر،
            مسئولیتی متوجه مِستربلیط نیست.
        </p>
        <p>
            7- خریدار موظف است درباره آیین‌نامه‌ها و مقررات سفر مثل میزان مجاز
            بار همراه و بار ممنوعه مطالعات مربوطه را انجام داده و به مسافران
            اطلاع‌رسانی لازم را انجام دهد و در صورت مطلع شدن از هرگونه تغییر یا
            کنسلی سفر، مراتب را به مسافرین اطلاع دهد. بدیهی است در صورت ایجاد
            مشکل در سفر و یا در صورت بروز مشکلاتی مانند گم شدن توشه و وسایل
            مسافر و یا تأخیر در شروع حرکت وسیله مسافرت، مسئولیتی متوجه مِستربلیط
            نیست.
        </p>
        <p>
            8- کلیه هزینه‌های قانونی از جمله بیمه و مالیات به عهده خریدار است.
        </p>
        <template #footer>
            <mr-button full-width @click="acceptTerms">
                شرایط را مطالعه نموده و می‌پذیرم.
            </mr-button>
        </template>
    </mr-modal>
</template>
